import ExchangeRate from './exchange-rate';

export default ExchangeRate;
